import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

/**
 * Form/detail loading placeholder — a stack of label + field pairs. Use for
 * form-shaped tabs and panels (details, settings, editors) instead of bare
 * "Loading…" text. See `.cursor/rules/loading-skeletons.mdc`.
 */
interface FormSkeletonProps {
  fields?: number
  className?: string
}

export const FormSkeleton = ({
  fields = 6,
  className,
}: FormSkeletonProps): JSX.Element => {
  return (
    <div
      className={cn('space-y-5', className)}
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading form"
    >
      {Array.from({ length: fields }).map((_, i) => (
        <div key={i} className="space-y-2">
          <Skeleton className="h-3.5 w-32 rounded" />
          <Skeleton className="h-9 w-full rounded-md" />
        </div>
      ))}
    </div>
  )
}
